import dayjs from 'dayjs';

const RANGE_DATE_KEY = 'pms_range_date';

export interface RangeDateStorage {
  startDate: string;
  endDate: string;
  period: number;
}

export const setRangeDate = (startDate: dayjs.Dayjs, endDate: dayjs.Dayjs, period: number) => {
  const rangeDateData: RangeDateStorage = {
    startDate: startDate.format('YYYY-MM-DD'),
    endDate: endDate.format('YYYY-MM-DD'),
    period
  };
  localStorage.setItem(RANGE_DATE_KEY, JSON.stringify(rangeDateData));
};

export const getRangeDate = (): RangeDateStorage | null => {
  const rangeDateString = localStorage.getItem(RANGE_DATE_KEY);
  if (!rangeDateString) return null;
  return JSON.parse(rangeDateString);
};

export const clearRangeDate = () => {
  localStorage.removeItem(RANGE_DATE_KEY);
};
